import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const ImageModuleExtraSpacing: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        marginTop: pxToRem(0),
        marginBottom: pxToRem(0),
    },
});
